import { Component, OnInit, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, NgZone, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn, } from '@angular/forms';
import { environment } from '../../../environments/environment';
import * as ResizeOption from 'ng2-imageupload';
import * as firebase from "firebase";
import { ElasticSearchService } from '../../_services/elastic-search.service';
import { Router, ActivatedRoute } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatHorizontalStepper, MatDialog, MatSnackBar, } from '@angular/material';
import { Subscription } from 'rxjs';
import { FirebaseError } from 'firebase';
import { AgreementComponent } from '../../directive/agreement/agreement.component';
import { DownloadImageService } from '../../_services/download-image.service';
import { ResizeOptions } from '../../_services/image-to-data-url/interfaces';
import { ImageToDataUrlService } from '../../_services/image-to-data-url/image-to-data-url.service';
import { UserService } from '../../_services/user.service';
import { } from '@angular/material/core';
import { PostService } from '../../_services/post.service';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { ScriptLoaderService } from '../../_services/script-loader.service';
import { PhoneAuthenticationService } from '../../_services/phone-authentication.service';
import { ApiService } from '../../_services/api.service';
import { BadwordsService } from '../../_services/badwords.service';

export class MyValidator {
  static notScored(rating): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (rating) {
        if (rating.criterias.every(data => !data.point)) {
          return { 'notScored': true }
        } else if (rating.criterias.filter(data => data.point != 0).length != 5) {
          return { 'IsMissingScorring': true };
        } else return null;
      } else {
        return { 'required': true }
      }
    };
  }
  static checkUsername(control: AbstractControl) {
    if (control.get("username").value.length >= 4)
      firebase.database().ref('entities/' + control.get("username").value.toLowerCase()).once('value', snap => {
        snap.exists() ? control.get('username').setErrors({ checkUsername: true }) : null
      }).catch(e => console.error(e));
  };
  static MatchPassword(AC: AbstractControl) {
    let password = AC.get('password').value; // to get value in input tag
    let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if (password != confirmPassword) {
      AC.get('confirmPassword').setErrors({ MatchPassword: true })
    } else {
      return null
    }
  }
  static ageControl(AC: AbstractControl) {
    try {
      // var myDate = AC.get('birthday').value;
      // myDate = myDate.split(".").join("/");
      let age = Date.now() - Number(new Date(AC.get('year').value + "-" + AC.get('month').value + "-" + AC.get('day').value));
      if (Math.floor(age / 1000 / 60 / 60 / 24 / 365.25) < 18) {
        AC.get('year').setErrors({ isNotElderly: true });
      } else {
        return null
      }
    } catch (e) {
    }
  }
}

@Component({
  selector: 'app-landing2',
  templateUrl: './landing2.component.html',
  styleUrls: ['./landing2.component.css'],
  providers: [
    // // The locale would typically be provided on the root module of your application. We do it at
    // // the component level here, due to limitations of our example generation script.
    // { provide: MAT_DATE_LOCALE, useValue: 'tr-TR' },

    // // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // // here, due to limitations of our example generation script.
    // { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    // { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
          ':enter', [
            style({ transform: 'translateX(-100%)', opacity: 0 }),
            animate('500ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
          ]
        ),
        transition(
          ':leave', [
            style({ transform: 'translateX(0)', 'opacity': 1 }),
            animate('500ms', style({ transform: 'translateX(-100%)', 'opacity': 0 }))
          ]
        )]),
    trigger(
      'myAnimation2',
      [
        transition(
          ':enter', [
            style({ transform: 'translateY(-100%)', opacity: 0 }),
            animate('500ms', style({ transform: 'translateY(0)', 'opacity': 1 }))
          ]
        ),
        transition(
          ':leave', [
            style({ transform: 'translateY(0)', 'opacity': 1 }),
            animate('500ms', style({ transform: 'translateY(-100%)', 'opacity': 0 }))
          ]
        )])
  ],
})
export class LandingComponent2 implements OnInit, OnDestroy {
  first = false;
  firstCodeSend = false;
  showPassword: boolean;
  showConfirmPassword: boolean;
  storagePath: any = environment.storagePath;
  private subscription: Subscription = new Subscription();
  entityText: any;
  editPost: any;
  user: any;
  registerControl = false;
  mode: boolean;
  userId: string;
  postKey: string;
  searchProperty: string;
  dismiss = new EventEmitter();
  lastUser;
  email: any;
  tekrarSms = false;
  sozlesme = false;
  blacklist = false;
  isCodeSent = false;
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  isStepPhoneVerify = false;

  @ViewChild('postText') private postText: ElementRef;
  @ViewChild('phone') private phone: ElementRef;
  @ViewChild('stepper') private stepper: MatHorizontalStepper;
  @Input() brand: any;
  input = '';
  public mentionConfig = { triggerChar: '@' && '#' };
  public rating: any;
  public progress: number;
  postSettingsRadio = true;
  public postSettings: any = {
    isOnlyFriend: false,
    isNameSecret: false,
    isGlobal: true,
    isAllowComments: false
  };
  hashtags =
    [{
      value: "#şikayetimvar",
      name: "ŞikayetimVar",
      disabled: false
    },
    {
      value: "#bunuçoksevdim",
      name: "BunuÇokSevdim",
      disabled: false
    },
    {
      value: "#markamaönerim",
      name: "MarkamaÖnerim",
      disabled: false
    },
    {
      value: "#benimtavsiyem",
      name: "BenimTavsiyem",
      disabled: false
    }];
  slideList = {};
  numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  files: any[] = [];
  isUploading = false;
  progressStatus: string = "progress-bar-animated";
  length = 0;
  arrayNumber: any[] = [];
  resizeOptions: ResizeOption.ResizeOptions = {
    resizeMaxHeight: 750,
    resizeMaxWidth: 750
  };
  averageRate: number = 0;
  isLinear = false;
  phoneWaiter = true;
  postFormGroup: FormGroup;
  rateFormGroup: FormGroup;
  registerFormGroup: FormGroup;
  phoneFormGroup: FormGroup;
  isCompleted = true;
  alert: any;
  isSeenDialog = true;
  shareButtonText = 'Paylaş';
  staticAlertClosed: boolean;
  loading: boolean;
  code: number;
  // startDate = new Date(1960, 0, 1);
  days = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15',
    '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
  months = [
    { month: 'Ocak', value: '01' },
    { month: 'Şubat', value: '02' },
    { month: 'Mart', value: '03' },
    { month: 'Nisan', value: '04' },
    { month: 'Mayıs', value: '05' },
    { month: 'Haziran', value: '06' },
    { month: 'Temmmuz', value: '07' },
    { month: 'Ağustos', value: '08' },
    { month: 'Eylül', value: '09' },
    { month: 'Ekim', value: '10' },
    { month: 'Kasım', value: '11' },
    { month: 'Aralık', value: '12' }];
  years = [];
  isMobile: boolean;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    private userService: UserService,
    private scriptLoader: ScriptLoaderService,
    private downloadImageService: DownloadImageService,
    private postService: PostService,
    public snackBar: MatSnackBar,
    private apiService: ApiService,
    private zone: NgZone,
    // private adapter: DateAdapter<any>,
    private imageResize: ImageToDataUrlService,
    private elasticSearchService: ElasticSearchService,
    private _formBuilder: FormBuilder,
    private badwordsService: BadwordsService,
    private phoneAuthService: PhoneAuthenticationService) {


    let dateNow = new Date();
    let currentYear = dateNow.getFullYear();
    for (let i = currentYear - 18; i > currentYear - 100; i--) {
      this.years.push(i);
    }

    this.isMobile = window.matchMedia("(max-width: 1024px)").matches;

  }

  ngOnInit() {
    this.phoneFormGroup = this._formBuilder.group({
      phoneNumber: ['', Validators.required],
      code: [{ value: "", disabled: true }, Validators.required]
    });
    this.postFormGroup = this._formBuilder.group({
      postInput: ['']
    });

    this.rateFormGroup = this._formBuilder.group({
      rateStep: ['', [Validators.required, MyValidator.notScored(this.rating)]]
    });

    this.registerFormGroup = this._formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      username: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      day: ['', Validators.required],
      month: ['', Validators.required],
      year: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      profileImage: ['no-image.png'],
      agreement: [false, Validators.required]
    }, {
        validator: [MyValidator.MatchPassword, MyValidator.checkUsername]
      });
    this.mode = this.route.snapshot.queryParams['mode'] == 3;
    if (this.route.snapshot.queryParams['mode'] == 1)
      try { this.postFormGroup.get("postInput").patchValue("@" + this.brand.uniqueName + " "); this.fakeInputKeyUp(); } catch (e) { };
    this.loadRating();
    this.cd.markForCheck();
    // this.adapter.setLocale('tr');
  }
  addTopic(index) {
    this.input = this.postFormGroup.get("postInput").value;
    this.hashtags[index].disabled = true;
    let caretPos = this.postText.nativeElement.selectionStart;
    this.input = this.input.substring(0, caretPos) + " " + this.hashtags[index].value + " " + this.input.substring(caretPos);
    this.postFormGroup.get("postInput").setValue(this.input);
    this.cd.markForCheck();
  }

  inputFocus() {
    document.getElementById("postText").classList.add("active");
  }
  public inputKeyUp(event: any) {

    if (event.which === 9 || event.keyCode === 9 ||
      event.which === 38 || event.keyCode === 38 ||
      event.which === 40 || event.keyCode === 40) {
      return;
    }
    this.input = this.postFormGroup.get("postInput").value;

    this.hashtags.filter(data => {
      data.disabled = this.input.indexOf(data.value) > -1;
    });

    if (this.input && this.input.length > 2 && this.route.snapshot.queryParams['mode'] == 1) {
      this.loadRating();
    }
  }

  public loadRating() {
    this.input = this.postFormGroup.get("postInput").value;
    const url = decodeURIComponent(this.router.url);
    var matches = this.input.match(/@[a-zA-Z0-9ğüşöçİĞÜŞÖÇ_]+/ig) || [];
    let whichOne = this.route.snapshot.queryParams['mode'] == 1 ? matches.map(match => match.substring(1)) : [url.split('/')[2].split('?')[0]]
    if (whichOne) {
      this.elasticSearchService.multipleSearchBy(whichOne).then((hits: any[]) => {
        const isRatingSame = hits.every(hit => {
          try { return hit.uniqueName == this.rating.uniqueName } catch (e) { return false }
        });
        if (hits.length != 0) {
          if (!isRatingSame) {
            this.rating = hits[0];
            this.rating.criterias.filter((criteria, i) => this.slideList[i] = i == 0);
            this.averageRate = 0;
          }
        } else if (hits.length == 0) {
          this.rating = null;
        }
        this.rateFormGroup.get("rateStep").setValidators(MyValidator.notScored(this.rating))

        this.rateFormGroup.get("rateStep").updateValueAndValidity();
        this.cd.markForCheck();
      });
    } else {
      this.rating = null;
      this.rateFormGroup.get("rateStep").setValidators(MyValidator.notScored(this.rating))

      this.rateFormGroup.get("rateStep").updateValueAndValidity();

      try { document.getElementsByClassName("modal-dialog")[0].classList.remove("big-model"); } catch (e) { }
    }

  }
  public selectSuggestion(selection) {
    if (selection.type == "advice") {
      this.dismiss.emit(false);
      this.router.navigate(['/product-advice']);
    } else {
      this.loadRating();
    }
  }

  slide(i) {
    this.slideList[i] = !this.slideList[i];
    try {
      if (!this.rating.criterias[i + 1].point) this.slideList[i + 1] = true
    } catch (e) { }
  }

  getAverageRate() {
    try {
      let total = this.rating.criterias.reduce((a, b) => {
        return a + b.point
      }, 0);
      let avg = total / (this.rating.criterias.filter(criteria => criteria.point != 0).length || 1)
      this.rateFormGroup.get("rateStep").setValidators(MyValidator.notScored(this.rating))
      this.rateFormGroup.get("rateStep").updateValueAndValidity();
      return avg
    } catch (e) {
      return 0;
    }
  }
  getGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  deleteFile(name) {
    this.files = this.files.filter(data => {
      return data.name != name;
    });
  }
  photoUpload(imageResult) {
    let src = imageResult.resized && imageResult.resized.dataURL || imageResult.dataURL;
    var storageRef = firebase.storage().ref();
    let newFileName = this.getGUID();
    var uploadTask = storageRef.child('files/' + newFileName).putString(src, "data_url");
    this.upload(uploadTask, () => {
      let media = {
        type: "image",
        name: newFileName
      };
      this.files.push(media);
    })
  }
  upload(uploadTask, callback) {
    this.isUploading = true;
    uploadTask.then(() => callback());
    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    uploadTask.on('state_changed', (snapshot: firebase.storage.UploadTaskSnapshot) => {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      this.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          break;
        case firebase.storage.TaskState.RUNNING: // or 'running'
          break;
      }
    }, (error: firebase.FirebaseError) => {
      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case 'storage/unauthorized':
          // User doesn't have permission to access the object
          break;

        case 'storage/canceled':
          // User canceled the upload
          break;
        case 'storage/unknown':
          // Unknown error occurred, inspect error.serverResponse
          break;
      }
    }, () => {
      this.isUploading = false;
    });
  }

  signUpWithGoogle() {

    let loginProvider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(loginProvider).then(res => {
      this.loading = true;
      this.signUpWithSocialIcon(res.user);
    }).catch(err => this.authErrors(err))
  }

  signUpWithFacebook() {

    let loginProvider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithPopup(loginProvider).then(res => {
      this.loading = true;
      this.signUpWithSocialIcon(res.user);
    }).catch(err => this.authErrors(err))
  }

  handleize(text) {
    return text.toString().toLowerCase()
      .replace(/\s/g, '')
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u');
  }

  signUpWithSocialIcon(data) {

  }
  public blobToFile = (theBlob: Blob, fileName: string): File => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }
  downloadUserProfileImage(imageURL): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscription.add(this.downloadImageService.getImage(imageURL).subscribe(image => {
        this.downloadImageService.upload(new Blob([new Uint8Array(image)]), this.userId).then(res => {
          let resizeOptions: ResizeOptions[] = [{
            maxHeight: 128,
            maxWidth: 128
          }, {
            maxHeight: 64,
            maxWidth: 64
          }, {
            maxHeight: 45,
            maxWidth: 45
          }];
          let count = 0;
          resizeOptions.forEach(option => {
            this.imageResize.readFiles([this.blobToFile(new Blob([new Uint8Array(image)]), "profileImage_" + option.maxHeight + "_thumb")], { resize: option }, imageResult => {
              if (imageResult.error) alert(imageResult.error);
              let src = imageResult.resized
                && imageResult.resized.dataURL
                || imageResult.dataURL;
              firebase.storage().ref('/files/' + this.userId).child("profileImage_" + option.maxHeight + "_thumb").putString(src, "data_url").then(() => {
                if (++count == resizeOptions.length) resolve(this.userId + '%2FprofileImage');
              });
            });
          })
        }).catch(err => {
          reject(err);
        });
      }))
    });
  }
  authErrors(err: FirebaseError) {
    switch (err.code) {
      case "auth/user-not-found": this.alert = { type: "danger", message: "Emin misin? Platformda böyle bir kullanıcı yok." }; break;
      case "auth/weak-password": this.alert = { type: "danger", message: "Oluşturacağın şifre en az 6 karakterden oluşmalıdır." }; break;
      case "auth/invalid-email": this.alert = { type: "danger", message: "E-posta adresin hatalı" }; break;
      case "auth/wrong-password": this.alert = { type: "danger", message: "Parolan geçersiz veya henüz şifren yok." }; break;
      case "auth/account-exists-with-different-credential": this.alert = { type: "danger", message: "Bu e-posta adresi zaten kullanılıyor." }; break;
      case "auth/email-already-in-use": this.alert = { type: "danger", message: "E-posta adresin, platformda başka bir kullanıcı tarafından kullanılıyor." }; break;
    }
    this.loading = false;
    this.dialog.open(SaveMessageComponent, {
      width: '400px',
      data: {
        message: this.alert.message,
        type: "update"
      }
    });
    // let ref = this.snackBar.open(this.alert.message, "Kapat");
    // ref.onAction().subscribe(() => {
    //   ref.dismiss();
    // });
    this.cd.markForCheck();
  }
  sameMail() {
    this.alert = { type: "danger", message: "E-posta adresin, platformda başka bir kullanıcı tarafından kullanılıyor." };
    this.loading = false;
    this.dialog.open(SaveMessageComponent, {
      width: '400px',
      data: {
        message: this.alert.message,
        type: "update"
      }
    });
    this.cd.markForCheck();
  }
  getStatus(): boolean {
    return this.userId ? true : this.registerFormGroup.valid
  }

  a(b) {
    return b.replace(/[^0-9]/g, '');
  }
  onlyLetterKeyForUserName(event) {
    let key = event.keyCode || event.charCode;
    return (key >= 65 && key <= 90)
      || (key >= 97 && key <= 122)
      || (key >= 48 && key <= 57)
      || key == 95;
  }

  dateFormat(data) {
    if (data.length == 10) {
      return data;
    }
    var dd = data.getDate();
    var mm = data.getMonth() + 1; //January is 0!
    var yyyy = data.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    data = yyyy + '-' + mm + '-' + dd;
    return data;
  }
  openAgreement(type) {
    this.dialog.open(AgreementComponent, {
      width: '50%',
      height: '82%',
      data: {
        type: type
      }
    });
  }
  public fakeInputKeyUp() {
    let keyboardEvent = document.createEvent("KeyboardEvent");
    let initMethod = typeof keyboardEvent.initKeyboardEvent !== 'undefined' ? "initKeyboardEvent" : "initKeyEvent";
    keyboardEvent[initMethod](
      "keyup", // event type : keydown, keyup, keypress
      true, // bubbles
      true, // cancelable
      window, // viewArg: should be window
      false, // ctrlKeyArg
      false, // altKeyArg
      false, // shiftKeyArg
      false, // metaKeyArg
      8, // keyCodeArg : unsigned long the virtual key code, else 0
    );
    this.inputKeyUp(keyboardEvent)
  }
  closeAlert() {
    this.staticAlertClosed = false;
    this.cd.markForCheck();
  }
  stepPostNext() {
    if (this.isSeenDialog && this.getAverageRate() === 1) {
      this.dialog.open(SaveMessageComponent, {
        width: '600px',
        data: {
          message: '<span class="landing-modal">Yaşadığın kesinlikle kötü bir deneyim olmalı... Ancak iyi olan hiçbir şey yok muydu? <br> Puanlamanı hem yaşadığın bu deneyim hem de genel marka algını düşünerek objektif bakış açısı ile gözden geçirmeni öneriyoruz.</span>',
          type: "update"
        }
      });
      this.shareButtonText = 'Tekrar paylaş';
      this.isSeenDialog = false;
    } else {
      this.stepper.next();
    }
  }
  phonenumber() {
    this.tekrarSms = true;
    this.isCodeSent = false;
    // this.phoneFormGroup.reset();
    this.phone.nativeElement.value = null;
    this.phoneFormGroup.get('code').disable();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}





// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/landing2/landing2.component.ts